export const svgMapper = {
    'Phone': 'svg-phone',
    'Email': 'svg-mail',
};

export const anchorTypeMapper = {
    'Phone': 'tel:',
    'Email': 'mailto:',
};